import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { PictureAsPdf, Description } from "@mui/icons-material";
import { observer } from "mobx-react-lite";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";

export interface DemoSamplesDialogProps {
  open: boolean;
  onClose: () => void;
}

export default observer(function DemoSamplesDialog({ open, onClose }: DemoSamplesDialogProps) {
  const t = (key: string) => translationService.translate(key);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("home.demo.dialog.title")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {t("home.demo.dialog.description")}
        </Typography>
        <Stack spacing={1.5}>
          <Button
            variant="outlined"
            component="a"
            href="/samples/inspection_report.pdf"
            target="_blank"
            rel="noopener"
            startIcon={<PictureAsPdf />}
          >
            {t("home.demo.dialog.viewPdf")}
          </Button>
          <Button
            variant="outlined"
            component="a"
            href="/samples/ISYBAU_2017-07.xml"
            target="_blank"
            rel="noopener"
            startIcon={<Description />}
          >
            {t("home.demo.dialog.downloadIsybau")}
          </Button>
          <Button
            variant="outlined"
            component="a"
            href="/samples/DWA-M150_04-2010.xml"
            target="_blank"
            rel="noopener"
            startIcon={<Description />}
          >
            {t("home.demo.dialog.downloadDwa")}
          </Button>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("home.demo.dialog.close")}</Button>
      </DialogActions>
    </Dialog>
  );
});
